<div class="menu-bar"></div>
<div class="menu-bar"></div>
<div class="menu-bar"></div>
